// extracted by mini-css-extract-plugin
module.exports = {"screen":"Screen_screen__3ph7I","screen-mini":"Screen_screen-mini__3Pdhy"};